<p-confirmDialog key="addalias" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Visitor Data-->
<div class="ItemBorder">
	<div class="MainGrid2Col">
		<label>Visitor:</label>
		<label class="InfoText">{{ FirstName }} {{ LastName }}</label>

		<label>License:</label>
		<label class="InfoText">{{ LicenseNbr }}</label>
	</div>
</div>

<!--Search for matches-->
<div class="ItemBorder TopMargin">
	<div class="MainGrid2Col">
		<label>Visitor Type:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="VisitorTypeID" [(ngModel)]="VisitorTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstVisitorType" [ngValue]="o.VisitorTypeID">
				{{ o.VisitorTypeDesc }}
			</option>
		</select>

		<label>Visitor Status:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="VisitorStatus" [(ngModel)]="VisitorStatusID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstVisitorStatus" [ngValue]="o.VisitorStatusID">
				{{ o.VisitorStatusDesc }}
			</option>
		</select>

		<label>Search For:</label>
		<input
			[disabled]="IsLoading() == true"
			type="text"
			class="form-control"
			style="min-width: 440px"
			[(ngModel)]="Filter"
			placeholder="Enter First Name, Last Name, License Number, State, Email, or Phone Number"
		/>

		<div class="CenterInGrid">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
		</div>
	</div>
</div>

<!--Possible Matches-->
<div class="ItemBorder TopMargin">
	<div>
		<p-table
			#mydt
			[value]="lstPerson"
			[loading]="LoadingTable"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedPersons"
			dataKey="PersonID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LicenseNbr-->
					<th>
						<p-columnFilter type="text" field="LicenseNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--State-->
					<th>
						<p-columnFilter field="State" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterState
									[ngModel]="value"
									[options]="lstState"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--Email-->
					<th>
						<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--PhoneNbr-->
					<th>
						<p-columnFilter type="text" field="PhoneNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--VisitorTypeDesc-->
					<th>
						<p-columnFilter field="VisitorTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterVisitorTypeDesc
									[ngModel]="value"
									[options]="lstVisitorTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--VisitorStatusDesc-->
					<th>
						<p-columnFilter field="VisitorStatusDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterVisitorStatusDesc
									[ngModel]="value"
									[options]="lstVisitorStatusDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="LicenseNbr">License<p-sortIcon field="LicenseNbr"></p-sortIcon></th>
					<th pSortableColumn="State">State<p-sortIcon field="State"></p-sortIcon></th>
					<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
					<th pSortableColumn="PhoneNbr">Phone<p-sortIcon field="PhoneNbr"></p-sortIcon></th>
					<th pSortableColumn="VisitorTypeDesc">Type<p-sortIcon field="VisitorTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="VisitorStatusDesc">Status<p-sortIcon field="VisitorStatusDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Person>
				<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Person[col.field] }}
					</td>

					<td
						[style.color]="Person.AllowAdmittance == true ? 'Black' : 'Red'"
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					>
						{{ Person.VisitorStatusDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-warning LeftMargin" (click)="onClose()">Cancel</button>
</div>
